import { BpAnchor } from '../../../../shared/components/text/anchor/BpAnchor'
import React from 'react'
import { CustomTag, TagsEditor } from '../../../../lib/widgets/tags-editor/TagsEditor'
import { useSearchParams } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '../../../../app/store/hooks/Redux'
import {
  selectOrganicResultsFilters,
  setOrganicResultsFilter,
} from '../../model/organicResultsSlice'
import { OrganicResultsFilterInterface } from '../../model/types/OrganicResultsFilter.interface'
import enhancedApi from '../../../../app/api'

interface DomainCellProps {
  domain: string
  has_brand?: boolean
  project: string
  tags: (string | CustomTag)[]
}

export const DomainCell = ({ domain, has_brand, project, tags }: DomainCellProps) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const filters = useAppSelector<OrganicResultsFilterInterface>(selectOrganicResultsFilters)
  const dispatch = useAppDispatch()

  const domainTags = [...(has_brand ? ['has_brand'] : []), ...tags]

  const handleDelete = (deletedTag: CustomTag) => {
    if (filters.tags?.split(',').includes(String(deletedTag.id))) {
      const filteredTags = filters.tags
        ?.split(',')
        .filter((tag) => tag !== String(deletedTag.id))
        .join(',')

      dispatch(
        setOrganicResultsFilter({
          ...filters,
          tags: filteredTags,
        }),
      )

      setSearchParams((searchParams) => {
        filteredTags ? searchParams.set('tags', filteredTags) : searchParams.delete('tags')

        return searchParams
      })
    }
  }

  const handleUnassign = (id: number) => {
    if (filters.tags?.split(',').includes(String(id))) {
      dispatch(enhancedApi.util.invalidateTags(['OrganicReport']))
    }
  }

  return (
    <div>
      <div>
        <BpAnchor className='flex-1 leading-5' href={`https://${domain}`} target='_blank'>
          {domain}
        </BpAnchor>
      </div>
      <div className='pt-[2px]'>
        <TagsEditor
          domain={domain}
          project={project}
          tags={domainTags}
          onDelete={handleDelete}
          onUnassign={handleUnassign}
        />
      </div>
    </div>
  )
}
